import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';
import AcademicPage from '../../views/AcademicPage/';

class Grade extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			grade : '',
			scale : '',
			lmark : '',
			umark : '',
			_message : '',
			alertClass :'',
			_redirect : false,
			posts: []
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	onClick(e){
		
		document.getElementById("graform").reset();
	}
	
	/** set value to react select **/
	handleChange(value){
		
		this.setState({value});
		console.log(this.state.value);
		
	}
	
	onSubmit(e){
		e.preventDefault();
		 $("#showLoader").show();
		PostData('exam/addgrade',this.state).then((result) => {
			 $("#showLoader").hide();
			let responseJson = result;
			if(responseJson.status == '1' ){
				this.setState({
					_message:'Grade Added Successfully!..',
					alertClass:'alert alert-success',
				});
				document.getElementById("graform").reset();
				this.getdata();
			}
			else{
		
				this.setState({
					_message:'Grade Already Added',
					alertClass:'alert alert-danger'
				});
				document.getElementById("graform").reset();
				this.getdata();
			}
		});
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) { 
           $("#showLoader").show();		
			PostData('exam/deletegrade',this.state).then((result) => {
				 $("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Grade Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Subject',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	onUpdate(dt){
		
		this.state.idd = dt;
		this.setState({_redirect: true});
		
	}
	
	componentDidMount() {
		 
		this.getdata();
	}
	
	getdata(){
		 $("#showLoader").show();
		GetData('exam/getgrade').then((result) => {
			 $("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
  render() {
	  
	if(this.state._redirect){
		  
		return (<Redirect to={'/subject/subjectupdate/' + this.state.idd} />);

	}
	
    return (
		<div>
		  <AcademicPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				  <Col md="5">
					<Card>
					  <form action="" method="post" role="form" id="graform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<CardHeader>
							<strong>Set Grade</strong>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Grade <span className="text-danger">*</span></Label>
								  <Input type="text" name="grade" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Lower Mark Range(in %) <span className="text-danger">*</span></Label>
								  <Input type="number" name="lmark" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Upper Mark Range(in %) <span className="text-danger">*</span></Label>
								  <Input type="number" name="umark" onChange={this.onChange} required />
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
							<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
						</CardFooter>
					  </form>
					</Card>
				  </Col>
				  <Col md="7">
				   <Card>
					<CardBody>
					<Table responsive bordered>
						<thead>
							<tr>
								<th>S.No</th>
								<th>Grade</th>
								<th>Lower Mark Range(in %)</th>
								<th>Upper Mark Range(in %)</th>
								<th width="100">Manage</th>
							</tr>
						</thead>
						<tbody>
							{this.state.posts.map(item =>
							 
								<tr key = {item}>
									<td>{item.id}</td>
									<td>{item.grade}</td>
									<td>{item.lowmark}</td>
									<td>{item.upmark}</td>
									<td>
										<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
									</td>
								</tr>

							 )}
						</tbody>
					</Table>
					</CardBody>
				   </Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default Grade;


// WEBPACK FOOTER //
// ./src/exams/Grade/Grade.js